import { getFontCss, styleConstants } from '@paywithextend/components'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import NotFoundBackgroundPage from 'src/components/NotFoundBackgroundPage/NotFoundBackgroundPage'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import TitleHeader from 'src/components/TitleHeader/TitleHeader'
import Topnav from 'src/components/Topnav/Topnav'
import { useBackgroundDispatch } from 'src/hooks'
import Trns from 'src/localization/Trns'
import OrganizationSettingsAppRoute from 'src/navigation/appRoutes/organization/organizationSettings.appRoute'
import { Rdrct } from 'src/navigation/Lnk'
import { expenseCategoriesUrl } from 'src/navigation/urls'
import { getOrganization } from 'src/redux/actions/data/organizations.actions'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import {
  selectOrganizationIdFromRoute,
  selectUserExplicitOrganizationListModelFromState,
} from 'src/redux/selectors/data/organizations.selectors'
import { selectLoadedFromRemoteConfigState } from 'src/redux/selectors/data/remoteConfig.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

const OrganizationSettings: React.FC<React.PropsWithChildren<unknown>> = () => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  const organizationId = useSelector(selectOrganizationIdFromRoute)
  const organization = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )

  const currentUser = useSelector(selectUserListModelFromState)
  const loadedRemoteConfig = useSelector(selectLoadedFromRemoteConfigState)
  const appName = useSelector(selectAppName)

  const dispatch = useBackgroundDispatch()
  useEffect((): void => {
    dispatch(getOrganization(organizationId, true))
  }, [])

  return loadedRemoteConfig ? (
    currentUser?.hasOrgBookkeeperPermissions ? (
      <>
        <Helmet>
          <title>{`Organization Settings | ${appName}`}</title>
          <meta
            name="description"
            content={`Organization Settings page of ${appName}`}
          />
        </Helmet>
        <BackgroundPage>
          <Topnav
            titleElements={{
              title: (
                <span
                  css={css`
                    ${getFontCss(
                      14,
                      styleConstants.colors.gray_darkest,
                      styleConstants.fontFamilies.medium,
                    )}
                  `}
                >
                  {organization?.name || ''}
                </span>
              ),
            }}
          />
          <TitleHeader title={<Trns source={'Organization Settings'} />} />
          <Switch location={calculatedBackgroundLocation}>
            {OrganizationSettingsAppRoute.subRoutes.map((route, i) => (
              <Route key={i} {...route.routeProps}>
                {route.component}
              </Route>
            ))}
            <Route {...OrganizationSettingsAppRoute.routeProps} exact>
              <Rdrct
                to={expenseCategoriesUrl(
                  organizationId !== undefined ? organizationId : '',
                )}
              />
            </Route>
            <Route path={'/'}>
              <NotFoundBackgroundPageContent />
            </Route>
          </Switch>
        </BackgroundPage>
      </>
    ) : (
      <NotFoundBackgroundPage />
    )
  ) : (
    <LoadingBackgroundPage />
  )
}

export default OrganizationSettings
